// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1728373499605
      var cssReload = require("/turing-ui/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  